import { Link } from 'react-router';

import { BillingPageWrapper } from '@page/billing/billing.page-style';
import { PageTitle } from '@style/pages/page.style';

export const BillingSuccessPage = () => {
  return (
    <BillingPageWrapper>
      <PageTitle>Subscription successful</PageTitle>

      <Link to='/account-settings'>Continue</Link>
    </BillingPageWrapper>
  );
};
